import axios from "axios";
import { baseURL } from "../Constants";
import { TierList, TierListSaveData, TierListResponse, TierListSummary, TierListItem, TierListAnswer, TierListRosterPlayer } from "../models/TierList";

const url = `${baseURL}/TierList`;

export const saveTierList = async (
    season: number,
    division: string,
    tierListType: 'teams' | 'players',
    tierData: TierListSaveData,
    token: string,
    tierListId?: number,
    basedOn?: number
): Promise<number> => {
    const response = await axios.post(`${url}/save`, {
        season, division, tierListType, tierData,
        tierListId: tierListId ?? null,
        basedOn: basedOn ?? null
    }, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.tierListId;
};

export const getTierListById = async (id: number): Promise<TierListResponse> => {
    const response = await axios.get(`${url}/${id}`);
    return response.data;
};

export const getMyTierList = async (
    season: number,
    division: string,
    type: string,
    token: string
): Promise<TierList | null> => {
    try {
        const response = await axios.get(`${url}/my`, {
            params: { season, division, type },
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (e: any) {
        if (e.response?.status === 404) return null;
        throw e;
    }
};

export const deleteTierList = async (id: number, token: string): Promise<void> => {
    await axios.delete(`${url}/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};

export const getAllMyTierLists = async (token: string): Promise<TierListSummary[]> => {
    const response = await axios.get(`${url}/all`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

/** Everyone who ranked this tierlist from its rank link. */
export const getTierListAnswers = async (id: number): Promise<TierListAnswer[]> => {
    const response = await axios.get(`${url}/${id}/responses`);
    return response.data;
};

/** A player's old teams (one card per season) or everyone they have played with. */
export const getCareerPool = async (steamId: string, type: 'teams' | 'players'): Promise<TierListItem[]> => {
    const response = await axios.get(`${url}/careerPool`, { params: { steamId, type } });
    return response.data;
};

/** Team-season cards whose team name contains the query. */
export const searchTeamSeasons = async (q: string): Promise<TierListItem[]> => {
    if (q.trim().length < 2) return [];
    const response = await axios.get(`${url}/teamSeasons`, { params: { q } });
    return response.data;
};

export const getTeamSeasonRoster = async (teamId: string, season: number): Promise<TierListRosterPlayer[]> => {
    const response = await axios.get(`${url}/roster`, { params: { teamId, season } });
    return response.data;
};
